import { useEffect, useState } from 'react';
const DEFAULT_DELAY = 3000;
export function useIdle(scheduler = DEFAULT_DELAY) {
    const innerScheduler = Array.isArray(scheduler)
        ? [...scheduler]
        : [scheduler];
    const getDelay = () => innerScheduler.length === 1 ? innerScheduler[0] : innerScheduler.shift();
    const [isIdle, setIsIdle] = useState(false);
    let timeoutId = null;
    const setIdleToFalse = () => {
        setIsIdle(false);
        clearTimeout(timeoutId);
    };
    const setIdleToTrue = () => {
        timeoutId = setTimeout(() => setIsIdle(true), getDelay());
    };
    useEffect(() => {
        setIdleToTrue();
        const toggleIdle = () => {
            setIdleToFalse();
            setIdleToTrue();
        };
        document.addEventListener('click', toggleIdle);
        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener('click', toggleIdle);
        };
    }, []);
    return { isIdle, setIdleToFalse, setIdleToTrue };
}
